<template>
  <NuxtLayout>
    <section class="brandList__Header container">
      <h1 v-text="page?.title" />
      <CMSField v-if="page?.content" :data="page.content" />
    </section>
    <BrandListing :data="page?.brands" />
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  defineProps({
    page: {}
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_brandList.scss');
</style>